import { PAGE_TYPE } from 'constants/general';

class AnalyticsService {
  /**
   * Push event to dataLayer for GTM
   * @param {string} eventName - GTM event name
   * @param {Object} eventData - Event data object
   */
  static pushEvent(eventName, eventData) {
    AnalyticsService._pushToDataLayer({ event: eventName, ...eventData });
  }

  static pushData(key, value) {
    AnalyticsService._pushToDataLayer({ [key]: value });
  }

  static _pushToDataLayer(data) {
    window.dataLayer = window.dataLayer || [];

    if (typeof window !== 'undefined' && data) {
      window.dataLayer.push(data);
    }
  }

  /**
   * Track exit intent modal impression
   * @param {string} modalName - Name of the modal
   */
  static trackExitIntentImpression(modalName = 'Exit Intent Modal') {
    this.pushEvent('exitIntentModalImpression', {
      eventCategory: 'Exit Intent',
      eventLabel: 'Modal Shown',
      modal_name: modalName,
    });
  }

  /**
   * Track exit intent modal click
   * @param {string} action - "confirm", "cancel", or "close"
   * @param {string} modalName - Name of the modal
   * @param {boolean} setCookie - Whether to set cookie for confirm actions (default: true)
   */
  static trackExitIntentClick(action, modalName = 'Exit Intent Modal') {
    const isConfirm = action === 'confirm';

    let eventLabel;
    switch (action) {
      case 'confirm':
        eventLabel = 'Clicked Yes';
        break;
      case 'cancel':
        eventLabel = 'Clicked No';
        break;
      case 'close':
        eventLabel = 'Clicked X button';
        break;
      default:
        eventLabel = 'Unknown Action';
    }

    this.pushEvent('exitIntentModalClick', {
      eventCategory: 'Exit Intent',
      eventLabel: eventLabel,
      eventValue: isConfirm ? 1 : 0,
      clickAction: action,
      modal_name: modalName,
    });
  }

  /**
   * Track page load
   * @param {Object} params
   * @param {string} params.pageType
   * @param {string} [params.campaignPageType] - Campaign page subtype (e.g., 'Brand', 'Offer', 'Paid Search', 'Partnership')
   */
  static trackPageDataLoaded({ pageType, campaignPageType }) {
    const isCampaignPage = pageType === PAGE_TYPE.CAMPAIGN;

    this.pushEvent('page_data_loaded', {
      is_campaign_page: isCampaignPage,
      page_type: isCampaignPage ? PAGE_TYPE.CAMPAIGN : null,
      campaign_page_type: campaignPageType || null,
    });
  }
}

export default AnalyticsService;
